import { render, staticRenderFns } from "./Infinite.vue?vue&type=template&id=dc10db18&scoped=true&"
import script from "./Infinite.vue?vue&type=script&lang=ts&"
export * from "./Infinite.vue?vue&type=script&lang=ts&"
import style0 from "./Infinite.vue?vue&type=style&index=0&id=dc10db18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc10db18",
  null
  
)

export default component.exports